<template>
    <div class="zoom-video-component">

        <div ref="videoCallPreview" class="video-call-preview d-flex" >
            <div class="main-video-container">
                <canvas id="doctorView"></canvas>
            </div>
            <div class="sub-video-list">
                <div>
                    <video id="selfView" class="self-view-video"></video>
                </div>
                <video-player-container v-pre></video-player-container>
            </div>
        </div>

        <!-- <video id="selfView" class="self-view-video"></video> -->
        <!-- <video-player-container v-pre></video-player-container> -->
    </div>
</template>

<script>
import ZoomVideo from '@zoom/videosdk';
export default {
    'name': 'ZoomVideo',
    'props': {
        'token': {
            'type': String
        },
        'participantName': {
            'type': String
        },
        'sessionName': {
            'type': String
        },
        'sessionKey': {
            'type': String
        }
    },
    data () {
        return {
            'zoomSession': null,
            'zoomVideo': null
        };
    },
    mounted () {
        const containerHeight = document.querySelector('.video-call-preview').clientHeight;

        const widthToSet = containerHeight / 9 * 16;

        document.querySelector('.main-video-container').style.width = `${widthToSet}px`;
        document.querySelector('#doctorView').width = `${widthToSet}`;
        document.querySelector('#doctorView').height = `${containerHeight}`;
    },
    'methods': {
        initialize () {
            this.zoomVideo = ZoomVideo.createClient();

            this.zoomVideo.init('en-US', 'Global', { 'patchJsMedia': true }).then(() => {
                this.zoomVideo
                    .join(this.sessionName, this.token, this.participantName)
                    .then(() => {
                        this.zoomSession = this.zoomVideo.getMediaStream();

                        this.zoomSession.startAudio();

                        this.zoomVideo.getAllUser().forEach((user, index) => {
                            if (user.bVideoOn) {
                                // this.zoomSession.attachVideo(user.userId, 3).then((userVideo) => {
                                //     document.querySelector('video-player-container').appendChild(userVideo);
                                // });
                                if (index === 0) {
                                    this.$emit('userConnected');
                                    const width = document.getElementById('doctorView').clientWidth;
                                    const height = document.getElementById('doctorView').clientHeight;
                                    this.zoomSession.renderVideo(document.getElementById('doctorView'), user.userId, width, height, 0, 0, 3);
                                }
                            }
                        });

                        if (this.zoomSession.isRenderSelfViewWithVideoElement()) {
                            this.zoomSession
                                .startVideo({ 'videoElement': document.getElementById('selfView') })
                                .then(() => {
                                // self video started and rendered
                                });
                        } else {
                            this.zoomSession.startVideo().then(() => {
                                this.zoomSession
                                    .renderVideo(
                                        document.getElementById('selfView'),
                                        this.zoomVideo.getCurrentUserInfo().userId, 1920, 1080, 0, 0, 3)
                                    .then(() => {
                                    // self video started and rendered
                                    });
                            });
                        }

                        this.zoomVideo.on('peer-video-state-change', (payload) => {
                            if (payload.action === 'Start') {
                                this.$emit('userConnected');
                                const width = document.getElementById('doctorView').clientWidth;
                                const height = document.getElementById('doctorView').clientHeight;
                                this.zoomSession.renderVideo(document.getElementById('doctorView'), payload.userId, width, height, 0, 0, 3);
                                // // a user turned on their video, render it
                                // this.zoomSession.attachVideo(payload.userId, 3).then((userVideo) => {
                                //     document.querySelector('video-player-container').appendChild(userVideo);
                                // });
                            } else if (payload.action === 'Stop') {
                                // a user turned off their video, stop rendering it
                                this.zoomSession.detachVideo(payload.userId);
                            }
                        });

                        this.zoomVideo.on('user-removed', (payload) => {
                            payload.forEach((user) => {
                                debugger;
                                this.zoomSession.detachVideo(user.userId);
                            });
                        });

                        this.$emit('connected');
                    });
            });
        },
        endCall () {
            if (this.zoomVideo !== null) {
                this.zoomVideo.leave(true);
            }
            this.$emit('ended');
        }
    }
};
</script>
<style>
.zoom-video-component {
    width: 100%;
    height: 100%;
}

.video-call-preview {
    height: 100%;
}

.main-video-container canvas{
    width: 100%;
    height: 100%;
    border: 1px solid #ccc;
}

.sub-video-list {
    width: 200px;
    height: 100%;
    overflow-y: auto;
}

.sub-video-list video-player-container {
    width: 100%;
}

.sub-video-list video,
.sub-video-list canvas,
.sub-video-list video-player {
    width: 100%;
    height: auto;
    aspect-ratio: 16/9;
}

</style>
